import React from "react"
import Loadable from 'react-loadable';
import Loading from './Motion-loading';
import {isMobile} from 'react-device-detect';

const LoadableComponent = Loadable({
  loader: () => import('./Motion-check'),
  loading: Loading
});

/*
 * IE cannot handle motion so if the browser is IE we render the children directly here
 * otherwise we hand off to a loadable react compontent to load motion at runtime thus avoiding IE alltogether
 *
 */
function FramerMotionAnimation({
  delay,
  children,
  opacityStart,
  transformXStart,
  transformYStart,
  opacityEnd,
  transformXEnd,
  transformYEnd,
}) {

  return (
    <div>
      {children}
    </div>
  )
  // if (typeof window === "undefined" || !window.document) {
  //   // SSR
  //   return (
  //     <div>
  //       {children}
  //     </div>
  //   )

  // } else {

  //   let isIE = /*@cc_on!@*/false || !!document.documentMode;
  //   if(!isMobile && isIE === false){
  //     // Not IE
  //     return (
  //       <LoadableComponent children={children} delay={delay} opacityStart={opacityStart} transformXStart={transformXStart} transformYStart={transformYStart} opacityEnd={opacityEnd} transformXEnd={transformXEnd} transformYEnd={transformYEnd} />
  //     );

  //   } else {
  //     // IE
  //     return (
  //       <div>
  //         {children}
  //       </div>
  //     )
  //   }
  // }
}

export default FramerMotionAnimation

